import { Component, inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CaseService } from '../../../services/case.service';
import { userService } from '../../../services/user-service';
import { AlphaSharedModule, PrimeNGModules } from '../../../shared/alpha-shared.module';

@Component({
    selector: 'app-recovery-modal',
    standalone: true,
    imports: [AlphaSharedModule, ...PrimeNGModules],
    templateUrl: './recovery-modal.component.html',
    styleUrl: './recovery-modal.component.scss',
})
export class RecoveryModalComponent {
    private readonly ref = inject(DynamicDialogRef);
    private readonly caseService = inject(CaseService);
    private config = inject(DynamicDialogConfig);
    private readonly userService = inject(userService);

    caseInstances: any;
    clientId!: string;
    messageService = inject(MessageService);
    ngOnInit() {
        this.caseInstances = this.config.data['caseInstances'];
        this.clientId = this.config.data['clientId'];
    }

    reAttempt() {
        this.caseService
            .reAttempt({
                caseInstances: this.caseInstances,
                clientId: this.clientId,
            })
            .subscribe((data: any) => {
                if (data.status == 'duplicate') {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: data.message,
                    });
                } else {
                    this.messageService.add({
                        severity: 'info',
                        summary: 'Info',
                        detail: data.message,
                    });
                }
                this.ref.close(true);
            });
    }

    close() {
        this.ref.close(false);
    }
}
